import React, { createContext, useContext, useMemo } from "react";
import PropTypes from "prop-types";
//Limitless imports
import { useDevLogging } from "@limitless/common/hooks/dev-logging/DevLoggingContext";
import { useTaskList } from "./ExpertTaskListHook";
// Set the default state values for each context
export const ExpertTaskListContext = /*#__PURE__*/createContext({});
export const ExpertTaskListContextProvider = ({
  children
}) => {
  const taskListContext = useTaskList();
  const {
    stateTracker
  } = useDevLogging();

  /**
   * useMemo ensures that expertTaskListContext is preserved unless certain state objects change value
   */
  const expertTaskListContext = useMemo(() => {
    stateTracker.trackState({
      tasklist: taskListContext.tasklist
    });
    stateTracker.trackState({
      tasklistFilters: taskListContext.tasklistFilters
    });
    return {
      ...taskListContext
    };
  }, [taskListContext.tasklist, taskListContext.tasklistFilters]);
  return /*#__PURE__*/React.createElement(ExpertTaskListContext.Provider, {
    value: expertTaskListContext
  }, children);
};
export const useExpertTaskListContext = () => {
  return useContext(ExpertTaskListContext);
};
ExpertTaskListContextProvider.propTypes = {
  children: PropTypes.node.isRequired
};